export enum JointType {
    REVOLUTE = 'revolute',
    PRISMATIC = 'prismatic',
    CONTINUOUS = 'continuous',
}
